import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();
const BASE_URL = process.env.REACT_APP_BASE_URL; // Adjust the base URL as needed

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); // ✅ Add loading state

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    const token = localStorage.getItem('token');

    if (storedUser && token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`; // 🔥 Add this line
      axios
        .post(`${BASE_URL}/api/auth/validate-token`, { token })

        .then((res) => {
          if (res.data.valid) {
            setUser(storedUser);
            setIsAuthenticated(true);
          } else {
            logout();
          }
        })
        .catch(logout)
        .finally(() => setLoading(false)); // ✅ Stop loading after check
    } else {
      setLoading(false); // ✅ No user/token, still stop loading
    }
  }, []);

  const login = async (userData, token) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', token);

    // 🔥 Record login time
    // try {
    //   await axios.post(`${BASE_URL}/api/auth/login-track`, { userId: userData.id });
    // } catch (err) {
    //   console.error("Login tracking failed", err);
    // }
  };

const logout = async () => {
  const storedUser = JSON.parse(localStorage.getItem('user'));
  const userId = storedUser?.id;

  if (userId) {
    try {
      await axios.post(`${BASE_URL}/api/auth/logout`, { userId });
    } catch (err) {
      console.error('Logout tracking failed', err);
    }
  }

  // Clear session and token
  setUser(null);
  setIsAuthenticated(false);

  // Remove all storage keys
  localStorage.removeItem('user');
  localStorage.removeItem('token');
  localStorage.removeItem('admin_id');
  localStorage.removeItem('doctor_id');
  localStorage.removeItem('receptionist_id');
  localStorage.removeItem('patient_id');
  localStorage.removeItem('lab_id');
  localStorage.removeItem('superadmin_id');

  // Remove axios header
  delete axios.defaults.headers.common['Authorization'];
    // ✅ Add direct navigation
  window.location.href = "/login"; 
};


  return (
    <AuthContext.Provider
      value={{ user, isAuthenticated, loading, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
